////////////////////////
// Util.js
////////////////////////

// パスワード強度チェック
export const checkPassword = password => {
  // パスワードの強度をチェック
  // 半角英数字8文字以上
  return /^[a-zA-Z0-9]{8,}$/.test(password)
}

// 法人番号のバリデーション
export const validateCorporateNumber = event => {
  let value = event.target.value

  // 全角数字を半角数字に変換
  value = convertToHalfWidthNumber(value)

  // 数字のみ許可
  value = value.replace(/[^0-9]/g, '')

  // 13桁を超える入力の場合、13桁に切り詰める
  if (value.length > 13) {
    value = value.substring(0, 13)
  }

  // 変換後の値を返す（formDataの更新は呼び出し側で行う）
  event.target.value = value
  return value
}

// 半角数字（スペースなし）に変換する関数
export const convertToHalfWidthNumber = str => {
  if (!str) return str

  // 全角数字を半角数字に変換
  let result = str.replace(/[０-９]/g, s => {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
  })

  // 数字以外の文字を削除
  result = result.replace(/[^0-9]/g, '')

  return result
}

// // 入力値を半角に変換するメソッド
// export const convertToHalfWidth = value => {
//   if (!value) return value

//   // 全角英数字を半角英数字に変換
//   return (
//     value
//       .replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => {
//         return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
//       })
//       // 全角スペースを半角スペースに変換
//       .replace(/　/g, ' ')
//   )
// }

// 半角を全角に変換する関数
export const convertToFullWidth = value => {
  if (!value) return value

  // Unicode正規化を使用して半角カナを全角カナに変換
  let result = value.normalize('NFKC')

  // 半角英数字を全角に変換
  result = result.replace(/[A-Za-z0-9!-~]/g, s => {
    return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
  })

  // 半角スペースを全角スペースに変換（normalize後も必要）
  result = result.replace(/ /g, '　')

  return result
}

// Base64文字列をArrayBufferに変換
export const base64ToArrayBuffer = base64 => {
  const binaryString = window.atob(base64)
  const bytes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes.buffer
}

// ArrayBufferをBase64文字列に変換
export const arrayBufferToBase64 = buffer => {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return window.btoa(binary)
}

/**
 * ひらがなをカタカナに変換する関数
 * @param {string} hiragana - 変換対象のひらがな
 * @returns {string} 変換後のカタカナ
 */
const hiraganaToKatakana = text => {
  if (!text) return ''

  return text.replace(/[\u3041-\u3096]/g, match => {
    const chr = match.charCodeAt(0) + 0x60
    return String.fromCharCode(chr)
  })
}
